import {
  useChangeIndicatorGroupMutation,
  useCreateIndicatorGroupMutation,
} from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";

export const getQuery = ({ closeModal, refetch, t }) => {
  const { notifySuccess, notifyError } = useNotify();

  const [createIndicatorGroup] = useCreateIndicatorGroupMutation({
    onCompleted() {
      closeModal();
      refetch();

      notifySuccess(t("common.сhange_was_successful"));
    },
    onError(vals) {
      notifyError(vals["message"]);
    },
  });

  const [editIndicatorGroup] = useChangeIndicatorGroupMutation({
    onCompleted() {
      closeModal();
      refetch();

      notifySuccess(t("common.сhange_was_successful"));
    },
    onError(vals) {
      notifyError(vals["message"]);
    },
  });

  return { createIndicatorGroup, editIndicatorGroup };
};
